'use client';
import MuiAvatar, { AvatarProps as MuiAvatarProps } from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';
import { WarningIcon } from '@/icons';
import { styles } from './utils';

export interface AvatarProps extends Omit<MuiAvatarProps, 'src'> {
  loading?: boolean;
  size?: number;
  label?: string;
  src?: string | null;
}

export default function Avatar({
  loading,
  size = 40,
  src,
  label,
  sx = {},
  ...props
}: AvatarProps) {
  if (loading) {
    return (
      <CircularProgress
        sx={styles.circularProgress}
        thickness={2}
        size={size}
      />
    );
  }
  const sharedProps = {
    sx: { ...styles.avatar(size, src), ...sx } as AvatarProps['sx'],
    ...props,
  };
  if (src) return <MuiAvatar src={src} {...sharedProps} />;
  else if (label) return <MuiAvatar {...sharedProps}>{label}</MuiAvatar>;
  return (
    <MuiAvatar {...sharedProps}>
      <WarningIcon />
    </MuiAvatar>
  );
}
